import React, { useRef, useState, useEffect } from "react";
import "./PoppupWIndow.css";
import axios from "axios";

const PopupWindow = ({
  isOpen,
  onClose,
  onSave,
  initialContent1,
  initialContent2,
  initialContent3,
  url,
}) => {
  const textAreaRef1 = useRef(null);
  const textAreaRef2 = useRef(null);
  const textAreaRef3 = useRef(null);
  const [blogContent, setBlogContent] = useState("");
  const [kbContent, setKbContent] = useState("");
  const [reviewContent, setReviewContent] = useState("");
  const [loading, setLoading] = useState(false);
  // const [editedContent, setEditedContent] = useState("");

  useEffect(() => {
    // Reset edited content when opening the popup
    if (isOpen) {
      setBlogContent(initialContent1);
      setKbContent(initialContent2);
      setReviewContent(initialContent3);
    }
  }, [isOpen, initialContent1, initialContent2,initialContent3,url]);

  const handleSave = () => {
    let newText1 = "";
    let newText2 = "";
    let newText3 = "";
    if (textAreaRef1.current) {
      newText1 = textAreaRef1.current.value;
    }
    if (textAreaRef2.current) {
      newText2 = textAreaRef2.current.value;
    }
    if (textAreaRef3.current) {
      newText3 = textAreaRef3.current.value;
    }
    onSave(newText1, newText2,newText3);
    // console.log(newText1);
    // console.log(newText2);
    onClose();
  };
  const refreshPromptData = async () => {
    setLoading(true);
    try {
      // Replace 'your_api_endpoint' with your actual API endpoint
      const response = await axios.get(url);
      console.log(url);
      if (response.status === 200) {
        setBlogContent(response.data.blogPrompt);
        setKbContent(response.data.kbPrompt);
        setReviewContent(response.data.reviewPrompt);
      } else {
        console.log("Failed to fetch new prompts");
      }
    } catch (error) {
      alert(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Edit Content</h2>
        <p>
          {" "}
          Remember to <strong>SAVE</strong> the prompt after making changes.
        </p>
        <div className="textarea-container">
          <div className="textarea-item">
            <h5>Blog Prompt:</h5>
            <textarea
              ref={textAreaRef1}
              value={blogContent}
              onChange={(e) => setBlogContent(e.target.value)} // Update editedContent
              className="edit-textarea"
              rows={40}
              cols={40} // Adjust cols to fit the layout
            />
          </div>
          <div className="textarea-item">
            <h5>Knowledge Base Prompt:</h5>
            <textarea
              ref={textAreaRef2}
              value={kbContent}
              onChange={(e) => setKbContent(e.target.value)} // Update editedContent
              className="edit-textarea"
              rows={40}
              cols={40} // Adjust cols to fit the layout
            />
          </div>
          <div className="textarea-item">
            <h5>review Prompt:</h5>
            <textarea
              ref={textAreaRef3}
              value={reviewContent}
              onChange={(e) => setReviewContent(e.target.value)} // Update editedContent
              className="edit-textarea"
              rows={40}
              cols={40} // Adjust cols to fit the layout
            />
          </div>
        </div>
        <div className="button-group">
          <button onClick={handleSave}>Save</button>
          <button onClick={refreshPromptData} disabled={loading}>
            {loading ? "Fetching..." : "Get Live Prompt"}
          </button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
export default PopupWindow;
